export default "__VITE_ASSET__Dq410sNK__"